import { atom, useAtomValue, useSetAtom } from 'jotai';

const isFinishNewbieAuthState = atom<boolean>(false);

export const useIsFinishNewbieAuth = () => useAtomValue(isFinishNewbieAuthState);
export const useSetIsFinishNewbieAuth = () => useSetAtom(isFinishNewbieAuthState);
